<template>
    <div>
        <nav class="nav_side col-lg-2 col-md-3 col-sm-3">
            <ul class="nav nav-pills nav-stacked affix">
                <li class="cdi_tab"><a href="https://recruiting.paylocity.com/recruiting/jobs/List/5139/CDI-Custom-Curb-Adapters">Job Openings</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "EmploymentNav",
}
</script>

<style scoped>

</style>